import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { getTokens, INK } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    root: {
      minWidth: 0,
      padding: 20,
      backgroundColor: t.paper,
      border: `1px solid ${t.line}`,
      borderRadius: t.radius.md,
      boxShadow: t.shadow.card,
    },
    flush: { padding: 0, overflow: "hidden" },
    head: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 8,
      marginBottom: 16,
    },
    headFlush: { margin: 0, padding: "16px 20px", borderBottom: `1px solid ${t.line}` },
    title: {
      margin: 0,
      fontFamily: t.font,
      fontSize: 15,
      fontWeight: 600,
      lineHeight: 1.4,
      color: t.mode === "dark" ? t.text : INK[800],
    },
    actions: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 8 },
  };
});

/**
 * Cartão de seção do painel: título 15px/600 e ações à direita, ambos opcionais.
 *
 * Props: `title?`, `actions?`, `flush?` (sem padding — para tabela encostada
 * nas bordas; o título ganha filete embaixo), `className?`.
 */
const Section = ({ title, actions, flush = false, className, children, ...rest }) => {
  const classes = useStyles();
  return (
    <section
      className={[classes.root, flush ? classes.flush : null, className].filter(Boolean).join(" ")}
      {...rest}
    >
      {(title || actions) && (
        <div className={[classes.head, flush ? classes.headFlush : null].filter(Boolean).join(" ")}>
          {title && <h2 className={classes.title}>{title}</h2>}
          {actions && <div className={classes.actions}>{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
};

export default Section;
